import { render, staticRenderFns } from "./MultiImagesDialog.vue?vue&type=template&id=a4558094"
import script from "./MultiImagesDialog.vue?vue&type=script&lang=ts"
export * from "./MultiImagesDialog.vue?vue&type=script&lang=ts"
import style0 from "./MultiImagesDialog.vue?vue&type=style&index=0&id=a4558094&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports